import { IApplicationState } from '../../types/redux';
import { IGeoUndergroundInfoSchema } from '../../../shared/repositories/newbuilding-card/entities/geo/GeoUndergroundInfoSchema';

export function getUndergroundInfo(state: IApplicationState): IGeoUndergroundInfoSchema[] | null {
  const {
    newbuilding: { geo },
  } = state;

  if (geo && geo.undergroundInfo && geo.undergroundInfo.length) {
    return geo.undergroundInfo;
  }

  return null;
}
